import { render, staticRenderFns } from "./PrecontractDetailView.vue?vue&type=template&id=266006fc&"
import script from "./PrecontractDetailView.vue?vue&type=script&lang=js&"
export * from "./PrecontractDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports